import { LANGUAGES } from '../i18n';

// Picking which version of a piece of text to show.
//
// A technician who writes an estimate in Spanish gets it stored twice: the
// English the server translated (what the admin reads, and what lands on the
// project statement) and their own words exactly as typed. Which one a reader
// sees depends only on the language they have the app set to:
//
//   globe set to Spanish  -> their own words, verbatim
//   globe set to anything else -> the English
//
// The point of keeping the original is that a tech re-reading their own
// estimate should never be shown a machine round-trip of their own writing.
// Records written in English have no original stored and this just returns the
// single value they do have.

// `sourceLang` is passed explicitly for line items, which carry their own
// `descriptionOriginal` but inherit the language from the parent estimate.
export const localized = (record, field, lang, sourceLang) => {
  if (!record) return '';
  const src = sourceLang !== undefined ? sourceLang : record.sourceLang;
  const original = record[`${field}Original`];
  if (original && src && lang === src) return original;
  return record[field] || '';
};

// True when this record was written in a language other than the one being
// read right now — i.e. the text on screen is a translation.
export const isTranslated = (record, lang) =>
  Boolean(record?.sourceLang) && record.sourceLang !== lang;

// "Spanish" / "Español" — the language a record was written in, in its own
// name, for the "translated from …" note.
export const sourceLangName = (record) =>
  LANGUAGES.find(l => l.code === record?.sourceLang)?.name || record?.sourceLang || '';
